define('views/content/login',[
  "backbone",
  "URIjs",
  "history",
  "jquery-placeholder"
], function (Backbone, URI, History) {
  "use strict";

  return Backbone.View.extend({
    events: {
      "click a.login": "setRedirectUrl",
      "shown.bs.popover": "focus"
    },

    initialize: function () {
      _.bindAll(this, "setRedirectUrl");
      this.render();
    },

    render: function () {
      var $popover = $("#login-popover");

      this.$("a.login").popover({
        html: "true",
        trigger: "click",

        title: function () {
          return $popover.find("h3").html();
        },

        content: function () {
          return $popover.find("section").html();
        }
      });

      return this;
    },

    focus: function () {
      this.$("[type = email]").focus();
    },

    // Set the value of the hidden #from field in the login form to the current
    // URL so that the user can be redirected onto the previous page after
    // a successful login
    setRedirectUrl: function (e) {
      var url = History.getState().url;
      e.preventDefault();
      this.$("#from").val(URI(url).normalizePathname().path());
    }
  });
});

